import LogoImage from "../assets/images/logo.png";
import NumberToPersian from "./NumberToPersian";
import { useEffect, useState } from "react";
import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";
import { useQuery } from "react-query";

const SideRefereeNew = (props) => {
  const [queryRun, setQueryRun] = useState(true);
  const [refNumber, setRefNumber] = useState(1);

  async function fetchData() {
    const localUserId = localStorage.getItem("refereeid");
    // if (!localUserId) {
    if (localStorage.getItem("refereeid") === null) {
      let response = await axiosConfig("referee-first-login.php");
      console.log(response.data);
      if (response.data.status == 1) {
        localStorage.setItem("refereeid", response.data.refereeid);
        setRefNumber(response.data.referee_number);
      }
    } else {
      let response = await axiosConfig(
        "referee-get-number.php?refereeid=" + localUserId
      );
      setRefNumber(response.data.referee_number);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  console.log("Referee Number is ", refNumber);

  let lastData = [];
  let userInfo = [];
  let matchState = "true";
  let playcode = null;
  let playnumber = 0;
  const localUserId = localStorage.getItem("refereeid");

  const { status, data, error, isFetching } = useQuery(
    "todos",
    async () => {
      const { data } = await axiosConfig.get(
        "get-points-side.php?refereeid=" + localUserId
      );
      return data;
    },
    {
      refetchInterval: 1000,
      enabled: queryRun,
    }
  );
  if (status === "success") {
    console.log(data);
    // userData(data.usersData);
    userInfo = data.usersData;
    lastData = data.pointdata;
    matchState = data.match_state;
    playcode = data.playcode;
    playnumber = data.playnumber;
    // setPointdata(data.pointdata);
  }

  // action  = {'increase' , 'decrease'}
  function clickHandle(color, pointtype, action) {
    try {
      const localRefereeId = localStorage.getItem("refereeid");
      axiosConfig
        .get(
          "register-point.php?refereeid=" +
            localRefereeId +
            "&color=" +
            color +
            "&pointtype=" +
            pointtype +
            "&action=" +
            action
        )
        .then((response) => {
          console.log("response= ", response);
          // setPointdata(response.data.pointdata);
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  const { fullname_red, fullname_blue } = userInfo;

  return (
    <>
      <div className="myNavbar">
        <div className="logo">
          <img src={LogoImage} alt="logo" />
        </div>
        <div className="details">
          بازی شماره {numberToPersian(playnumber)} | داور شماره{" "}
          {NumberToPersian(refNumber)}
        </div>
      </div>
      <div className="container-full">
        {matchState === "true" && (
          <div className="row text-center mt-2">
            <p className="match-details" style={{ fontSize: "20px" }}>
              راند {lastData.round ? numberToPersian(lastData.round) : 1}
            </p>
          </div>
        )}
        {matchState === "true" && (
          <div className="row text-center  wrestler-details">
            <div className="col-6 col-sm-6 wrestler-area">
              <div className="wrestler">
                <h5 className="IRANSansNormal">{fullname_red}</h5>
                <span
                  className="badge bg-danger IRANSansNormal mt-2"
                  style={{ fontSize: "22px" }}
                >
                  {lastData.redpoint !== 0
                    ? numberToPersian(lastData.redpoint)
                    : 0}
                </span>
              </div>
            </div>
            <div className="col-6 col-sm-6 wrestler-area">
              <div className="wrestler">
                <h5 className="IRANSansNormal">{fullname_blue}</h5>
                <span
                  className="badge bg-primary IRANSansNormal mt-2"
                  style={{ fontSize: "22px" }}
                >
                  {lastData.bluepoint !== 0
                    ? numberToPersian(lastData.bluepoint)
                    : 0}
                </span>
              </div>
            </div>
          </div>
        )}
        {matchState === "true" && (
          <div className="row text-center mt-5">
            <div className="col-6 col-sm-6">
              <div className="row">
                <div
                  className="col-10 col-sm-10 one-panel bg-danger"
                  onClick={() => clickHandle("red", 2, "increase")}
                >
                  <h1 className="IRANSansBold">+ {numberToPersian(2)}</h1>
                </div>
                <div
                  className="col-2 col-sm-2 one-panel bg-danger"
                  style={{ borderLeft: "5px solid #e1e1e1" }}
                  onClick={() => clickHandle("red", 2, "decrease")}
                >
                  <h1 className="IRANSansBold">-</h1>
                </div>
              </div>
            </div>

            <div className="col-6 col-sm-6">
              <div className="row">
                <div
                  className="col-2 col-sm-2 one-panel bg-primary"
                  style={{ borderRight: "5px solid #e1e1e1" }}
                  onClick={() => clickHandle("blue", 2, "decrease")}
                >
                  <h1 className="IRANSansBold">-</h1>
                </div>
                <div
                  className="col-10 col-sm-10 one-panel bg-primary"
                  onClick={() => clickHandle("blue", 2, "increase")}
                >
                  <h1 className="IRANSansBold">+ {numberToPersian(2)}</h1>
                </div>
              </div>
            </div>
          </div>
        )}
        {matchState === "true" && (
          <div className="row text-center mt-3 mb-5">
            <div className="col-6 col-sm-6">
              <div className="row">
                <div
                  className="col-10 col-sm-10 one-panel bg-danger"
                  disabled={true}
                  onClick={() => clickHandle("red", 1, "increase")}
                >
                  <h1 className="IRANSansBold">+ {numberToPersian(1)}</h1>
                </div>
                <div
                  className="col-2 col-sm-2 one-panel bg-danger"
                  style={{ borderLeft: "5px solid #e1e1e1" }}
                  disabled={true}
                  onClick={() => clickHandle("red", 1, "decrease")}
                >
                  <h1 className="IRANSansBold">-</h1>
                </div>
              </div>
            </div>
            <div className="col-6 col-sm-6">
              <div className="row">
                <div
                  className="col-2 col-sm-2 one-panel bg-primary"
                  style={{ borderRight: "5px solid #e1e1e1" }}
                  onClick={() => clickHandle("blue", 1, "decrease")}
                >
                  <h1 className="IRANSansBold">-</h1>
                </div>
                <div
                  className="col-10 col-sm-10 one-panel bg-primary"
                  onClick={() => clickHandle("blue", 1, "increase")}
                >
                  <h1 className="IRANSansBold">+ {numberToPersian(1)}</h1>
                </div>
              </div>
            </div>
          </div>
        )}

        {matchState === "false" && (
          <div className="row text-center mt-3 mb-5">
            <div className="col-12 col-sm-12">
              <p
                className="mt-5 IRANSansNormal text-danger"
                style={{ direction: "rtl", fontSize: "14px" }}
              >
                بازی فعلی به اتمام رسیده است. منتظر شروع بازی جدید باشید!
              </p>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SideRefereeNew;
